import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import { Typography } from '../typography';

import styles from './hint.scss';

const COMPONENT_ID = 'modulor-hint';

export type HintProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    hint?: string;
    dataTestId?: string;
  };

export const Hint: ForwardRefExoticComponent<HintProps> = forwardRef<HTMLDivElement, HintProps>(
  ({ hint = '', dataTestId = COMPONENT_ID, className, ...rest }, ref) => {
    if (!hint?.length) {
      return null;
    }

    return (
      <div
        className={classNames(className, styles.hint)}
        ref={ref}
        data-id={dataTestId}
        data-testid={dataTestId}
        data-component-name={COMPONENT_ID}
        {...rest}>
        <Typography variant="caption-1-regular">{hint}</Typography>
      </div>
    );
  },
);

Hint.displayName = 'Hint';
